import React from 'react';
import {observer} from 'mobx-react';
import PropTypes from 'prop-types';
import {lowerCaseAllWordsExceptFirstLetter} from 'ferries/helpers/common';

const getLabel = (isHomePage, account, title, welcomeUser) => {
  if (isHomePage && account?.userAccountID) {
    return welcomeUser.replace('{name}', lowerCaseAllWordsExceptFirstLetter(account.firstName));
  }

  return title;
};

const Title = ({navbar, title, isHomePage}) => {
  const {account, translations} = navbar;
  const label = getLabel(isHomePage, account, title, translations.welcomeUser);

  return (
    <>
      {
        label &&
          <h1 className="text-white w-lg-1-1 mb-2">
            {label}
          </h1>
      }
    </>
  );
};

Title.propTypes = {
  navbar: PropTypes.object.isRequired,
  isHomePage: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired
};

Title.defaultProps = {
  title: ''
};

export default observer(Title);
